exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3Uyj6--kdBeT_tB3LV786g{padding:1.42857rem}@media only screen and (min-width:640px){._3Uyj6--kdBeT_tB3LV786g{padding:1.42857rem 2.14286rem}}.LTe65KZPaZPwtNMSSF_OE{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;width:-webkit-calc(100% + 1.78571rem);width:-moz-calc(100% + 1.78571rem);width:calc(100% + 1.78571rem)}.LTe65KZPaZPwtNMSSF_OE span{max-width:-webkit-calc(100% - 1.78571rem);max-width:-moz-calc(100% - 1.78571rem);max-width:calc(100% - 1.78571rem)}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AttendanceHistory": "_3Uyj6--kdBeT_tB3LV786g",
	"AttendanceHistory_table_dateTimeHeader": "LTe65KZPaZPwtNMSSF_OE"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Attendance/AttendanceHistory/style.postcss
// module id = 1320
// module chunks = 0